module.exports = __webpack_public_path__ + "img/title.48eca45a.svg";